export const MOBILE_PHONE = 'mobilePhone';
export const EMAIL = 'email';
export const SEARCH_PERMISSION = 'searchPermission';